import http from "@/libs/http";
const login = {
  /**密码登录 */
  login: loginVO => {
    return http.post(http.formatUrl("login/password"), loginVO);
  }
};
export default login;
